<script>
	// Custom line marks rather than a stock icon set: these eight points are
	// specific Tasmanian places and experiences, and no generic library covers
	// a colonial village, a brewery or Tasmanian seafood without reaching.
	import Tankard from './icons/Tankard.svelte';
	import Cottage from './icons/Cottage.svelte';
	import BreweryKettle from './icons/BreweryKettle.svelte';
	import Scallop from './icons/Scallop.svelte';
	import BallOnTee from './icons/BallOnTee.svelte';
	import Bed from './icons/Bed.svelte';
	import Cards from './icons/Cards.svelte';
	import TrophyCup from './icons/TrophyCup.svelte';

	const experiences = [
		{ icon: Tankard, title: 'Historic pubs & country hospitality' },
		{ icon: Cottage, title: 'Colonial villages & rich history' },
		{ icon: BreweryKettle, title: 'Cascade Brewery' },
		{ icon: Scallop, title: 'Fresh Tasmanian seafood & local flavours' },
		{ icon: BallOnTee, title: 'The Range welcome event' },
		{ icon: Bed, title: 'Premium accommodation' },
		{ icon: Cards, title: 'Games, competitions & plenty of laughs' },
		{ icon: TrophyCup, title: 'Golfer of the Trip & Legends Trophy' }
	];
</script>

<!-- Opens the grey block that continues through the gallery carousel below, so
     the two read as one section. -->
<section id="experience" class="bg-secondary pt-16 lg:pt-24">
	<div class="mx-auto max-w-7xl px-4">
		<div class="mx-auto max-w-3xl text-center">
			<p class="text-sm font-semibold uppercase tracking-widest text-[#194139]">
				The Tasmanian experience
			</p>
			<h2 class="mt-3 font-heading text-3xl font-semibold tracking-tight sm:text-4xl">
				Everything that happens between the rounds
			</h2>
		</div>

		<ul class="mt-14 grid grid-cols-1 gap-x-10 sm:grid-cols-2 lg:grid-cols-4">
			{#each experiences as experience}
				<li class="flex flex-col gap-5 border-t border-[#194139]/20 py-7">
					<experience.icon class="h-9 w-9 text-[#194139]" />
					<h3 class="font-heading text-base font-semibold leading-snug">{experience.title}</h3>
				</li>
			{/each}
		</ul>
	</div>
</section>
